"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ssrWindow = require("ssr-window");
var _each = _interopRequireDefault(require("lodash/each"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _some = _interopRequireDefault(require("lodash/some"));
var _storage = _interopRequireDefault(require("../storage/storage"));
const makeTrackingCall = ({
  event,
  properties,
  additionalOptions = null,
  callback = null
}) => {
  if (_ssrWindow.window.analytics && !(0, _isFunction.default)(_ssrWindow.window.analytics.track)) {
    return;
  }
  _ssrWindow.window.analytics.track(event, properties, additionalOptions, callback);
};
const logTrackingCall = ({
  event,
  properties,
  additionalOptions = null,
  callback = null
}) => {
  // eslint-disable-next-line no-console
  console.log(`Segment - Track: ${event}, Properties: ${JSON.stringify(properties, null, 4)}, Additional Options: ${JSON.stringify(additionalOptions, null, 4)}`);
  if (callback) {
    callback();
  }
};
const postReady = onLoad => {
  const clientFingerprint = _storage.default.get('sh-client-fingerprint', 'cookie');
  const segmentAnonymousId = _storage.default.get('ajs_anonymous_id', 'cookie');
  if (!(0, _isNil.default)(clientFingerprint) && !(0, _isNil.default)(segmentAnonymousId) && clientFingerprint !== segmentAnonymousId) {
    _ssrWindow.window.analytics.user().anonymousId(clientFingerprint);
  }
  if ((0, _isFunction.default)(onLoad)) {
    onLoad();
  }
};
let segmentQueue = [];
let debugMode = false;
let loadInterval;

/**
 * Utilities for working with Segment.
 * @module SegmentUtils
 */
const SegmentUtils = {
  /**
   * Loads and initializes Segment's analytics.js library.
   * @static
   * @function init
   * @param {Object} data - The data used to initialize Segment.
   * @param {String} data.apiKey - The Segment API key.
   * @param {Function} [data.onLoad] - A callback function to execute once all enabled destinations have loaded and Segment has completed initialization.
   * @param {Boolean} [data.debug=false] - Puts SegmentUtils into debug mode and just logs all events to the console.
   * @example
   * SegmentUtils.init({apiKey: 'ABCDEFG'});
   * @returns {void}
   */
  init({
    apiKey,
    onLoad,
    debug = false
  }) {
    if ((0, _isNil.default)(apiKey)) {
      throw new Error(`Missing required argument "apiKey".`);
    }
    if (!debug) {
      /* eslint-disable */
      !function () {
        var analytics = _ssrWindow.window.analytics = _ssrWindow.window.analytics || [];
        if (!analytics.initialize) if (analytics.invoked) _ssrWindow.window.console && console.error && console.error('Segment snippet included twice.');else {
          analytics.invoked = !0;
          analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'user'];
          analytics.factory = function (t) {
            return function () {
              var e = Array.prototype.slice.call(arguments);
              e.unshift(t);
              analytics.push(e);
              return analytics;
            };
          };
          for (var t = 0; t < analytics.methods.length; t++) {
            var e = analytics.methods[t];
            analytics[e] = analytics.factory(e);
          }
          analytics.load = function (t) {
            var e = _ssrWindow.document.createElement('script');
            e.type = 'text/javascript';
            e.async = !0;
            e.src = ('https:' === _ssrWindow.document.location.protocol ? 'https://' : 'http://') + 'cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js';
            var n = _ssrWindow.document.getElementsByTagName('script')[0];
            n.parentNode.insertBefore(e, n);
          };
          analytics.SNIPPET_VERSION = '4.0.0';
          _ssrWindow.window.analytics.load(apiKey);
          _ssrWindow.window.analytics.ready(postReady);
        }
      }();
      /* eslint-enable */
    } else {
      debugMode = true;
      if ((0, _isFunction.default)(onLoad)) {
        onLoad();
      }
    }
  },
  /**
   * Associates users and their actions to a recognizable user ID and traits.
   * @static
   * @function identify
   * @param {Object} data - The data to associate to the user.
   * @param {String} [data.uniqueId] - The ID for the user.
   * @param {Object} [data.traits] - A dictionary of traits about the user.
   * @param {Object} [data.options] - A dictionary of options.
   * @example
   * SegmentUtils.identify({
   *     uniqueId: 'userId123'
   *     traits: {
   *         email: user.email,
   *         created: user.dateJoined,
   *         name: user.displayName,
   *     }
   * });
   * @returns {void}
   */
  identify({
    uniqueId,
    traits = {},
    options = {}
  }) {
    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }
      const args = [];
      if (!(0, _isNil.default)(uniqueId)) {
        args.push(uniqueId.toString());
      }
      args.push(traits, options);
      _ssrWindow.window.analytics.identify(...args);
    } else {
      // eslint-disable-next-line no-console
      console.log('Segment - Identify:', uniqueId, ', Traits: ', traits, ', Options: ', options);
    }
  },
  /**
   * Combines two previously unassociated user identities.
   * @static
   * @function alias
   * @param {Object} data - The data to associate to the user.
   * @param {String} data.uniqueId - The ID for the user.
   * @param {Object} [data.previousId] - The previous ID of the user.
   * @example
   * SegmentUtils.alias({
   *     uniqueId: 'userId123'
   *     previousId: 'userId456'
   * });
   * @returns {void}
   */
  alias({
    uniqueId,
    previousId
  }) {
    if ((0, _isNil.default)(uniqueId)) {
      throw new Error(`Missing required argument "uniqueId".`);
    }
    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }
      if (uniqueId && previousId) {
        _ssrWindow.window.analytics.alias(uniqueId, previousId);
      } else {
        _ssrWindow.window.analytics.alias(uniqueId);
      }
    } else {
      // eslint-disable-next-line no-console
      console.log('Segment - Alias:', uniqueId, ', Previous ID: ', previousId);
    }
  },
  /**
   * Sends page data to Segment.
   * @static
   * @function page
   * @param {Object} [data={}] - The data to send to Segment.
   * @param {String} [data.name=null] - The page name.
   * @param {Object} [data.properties=null] - The page properties object. See the properties object information <a href="https://segment.com/docs/spec/page/#properties" target="_blank">here</a> for details.
   * @param {Function} [data.callback=null] - A function that is executed after a short timeout, giving the browser time to make outbound requests first.
   * @example
   * SegmentUtils.page({
   *     name: 'Search',
   *     properties: {
   *         path: '/search'
   *     }
   * });
   * @returns {void}
   */
  page({
    name = null,
    properties = null,
    additionalOptions = null,
    callback = null
  } = {}) {
    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        return;
      }

      /*
          An empty `page` call is translated by Segment as:
          window.analytics.page('Default Page Name', {
              title: 'Default Page Title',
              url: 'Default full url',
              path: 'Default path',
              referrer: 'Default referrer'
          });
           Otherwise, page name and properties can be overridden together or separately.
      */

      _ssrWindow.window.analytics.page(...[name, properties, !properties && additionalOptions ? {} : null,
      // additionalOptions must be passed as the second object even if there are no properties
      additionalOptions, callback].filter(Boolean));
    } else {
      /* eslint-disable no-console */
      console.log('Segment - Page:', {
        page: name || 'Default Page Name',
        properties: properties || 'Default Page Properties',
        additionalOptions: additionalOptions || 'Default Additional Options'
      });
      /* eslint-enable no-console */

      if (callback) {
        callback();
      }
    }
  },
  /**
   * Sends tracking event data to Segment.
   * @static
   * @function track
   * @param {Object} [data={}] - The data to send to Segment.
   * @param {String} data.event - The event name.
   * @param {Object} [data.properties=null] - The event properties object. See the properties object information <a href="https://segment.com/docs/spec/track/#properties" target="_blank">here</a> for details.
   * @param {Object} [data.additionalOptions=null] - Additional options to send with the event.
   * @param {Function} [data.callback=null] - A function that is executed after a short timeout, giving the browser time to make outbound requests first.
   * @example
   * SegmentUtils.track({
   *     event: 'Searched',
   *     properties: {
   *         city: 'Chicago'
   *     }
   * });
   * @returns {void}
   */
  track(data) {
    if ((0, _isNil.default)(data) || (0, _isArray.default)(data) && (0, _some.default)(data, ({
      event
    }) => (0, _isNil.default)(event)) || !(0, _isArray.default)(data) && (0, _isNil.default)(data.event)) {
      throw new Error(`Missing required argument "event".`);
    }
    if (!debugMode) {
      if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
        if ((0, _isArray.default)(data)) {
          segmentQueue.concat(data);
        } else {
          segmentQueue.push(data);
        }
        if (!loadInterval) {
          loadInterval = _ssrWindow.window.setInterval(() => {
            if (!_ssrWindow.window.analytics) {
              return;
            }
            _ssrWindow.window.clearInterval(loadInterval);
            (0, _each.default)(segmentQueue, (item, i) => {
              SegmentUtils.track(item);
              if (i === segmentQueue.length - 1) {
                segmentQueue = [];
              }
            });
          }, 100);
        }
        return;
      }
      if ((0, _isArray.default)(data)) {
        (0, _each.default)(data, trackingCall => {
          makeTrackingCall(trackingCall);
        });
      } else {
        makeTrackingCall(data);
      }
    } else {
      if ((0, _isArray.default)(data)) {
        (0, _each.default)(data, trackingCall => {
          logTrackingCall(trackingCall);
        });
      } else {
        logTrackingCall(data);
      }
    }
  },
  /**
   * A function to execute once all enabled destinations have loaded and Segment has completed initialization.
   * @static
   * @function onReady
   * @param {Function} cb - The function to execute.
   * @example
   * SegmentUtils.onReady(() => {
   *     console.log('Segment is ready!');
   * });
   * @returns {void}
   */
  onReady(cb) {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return;
    }
    if (!debugMode) {
      if ((0, _isFunction.default)(cb)) {
        _ssrWindow.window.analytics.ready(cb);
      }
    } else {
      if ((0, _isFunction.default)(cb)) {
        cb();
      }
    }
  },
  /**
   * Allows consumers of the util to get the anonymous id if the user have been identified or not.
   * @static
   * @function getAnonymousId
   * @example
   * SegmentUtils.getAnonymousId();
   * @returns {(String|null)} Returns the segment anonymous ID, null if there was a problem
   */
  getAnonymousId() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }
    const user = _ssrWindow.window.analytics.user();
    const anonymousId = (0, _isFunction.default)(user.anonymousId) ? user.anonymousId() : null;
    return anonymousId;
  },
  /**
   * Allows consumers of the util to get the segment user id
   *
   * Segment will return the anonymous ID until a `identify` occurs, after that point the
   * user id supplied in to `identify` will be returned.
   * @static
   * @function getId
   * @example
   * SegmentUtils.getId();
   * @returns {(String|null)} Returns the segment user ID, null if there was a problem
   */
  getId() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }
    const user = _ssrWindow.window.analytics.user();
    const id = (0, _isFunction.default)(user.id) ? user.id() : null;
    const anonymousId = this.getAnonymousId();
    return !(0, _isNil.default)(id) ? id : anonymousId;
  },
  /**
   * Allows consumers of the util to get the segment user traits
   *
   * Segment will return nothing until a `identify` occurs, after that point the
   * user traits supplied in to `identify` will be returned.
   * @static
   * @function getId
   * @example
   * SegmentUtils.getUserTraits();
   * @returns {(Object|null)} Returns the segment user traits, null if there was a problem or user isn't logged in
   */
  getUserTraits() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }
    const user = _ssrWindow.window.analytics.user();
    const traits = (0, _isFunction.default)(user.traits) ? user.traits() : null;
    return traits;
  },
  /**
   * Allows consumers of the util to call the segment reset.
   *
   * @static
   * @function reset
   * @example
   * SegmentUtils.reset();
   * @returns {void}
   */
  reset() {
    if ((0, _isNil.default)(_ssrWindow.window.analytics)) {
      return null;
    }
    _ssrWindow.window.analytics.reset();
  },
  /**
   * Waits for Segment SDK to load and then runs function.
   *
   * @static
   * @function waitForSegmentThenLoad
   * @param {number} maxWaitTime - Amount of time to wait for Segment SDK to load (in milliseconds)
   * @param {Function} loadFunction - function to be run after waiting for Segment SDK
   * @param {object} objectToPass - Object to pass to the loadFunction (probably for tracking)
   * @param {object} config - isSegmentEnabled and isDeployed booleans
   * @example
   * SegmentUtils.waitForSegmentThenLoad(
   *      5000,
   *      loadSpots,
   *      {searchTrackingAction: 'EVENT'}
   * )
   * @returns {void}
   */
  waitForSegmentThenLoad(maxWaitTime, loadFunction, objectToPass = null, config = {}) {
    const runFunction = () => {
      if (objectToPass) {
        loadFunction(objectToPass);
      } else {
        loadFunction();
      }
    };

    // if we have Segment enabled and expect it to run
    if (config.isSegmentEnabled && config.isDeployed) {
      // It is possible that the Segment SDK fails for some
      // reason and our onReady callback never gets called.
      // Set a timeout in that case, for the maximum
      // amount of time we want to wait for Segment to be ready.
      const segmentReadyTimeoutID = setTimeout(() => {
        runFunction();
      }, maxWaitTime);
      this.onReady(() => {
        // clear the timeout, since Segment is ready now
        clearTimeout(segmentReadyTimeoutID);

        // It is technically possible that this happens after the
        // timeout function has been executed.
        // Is it worth solving for?
        runFunction();
      });
    } else {
      // else we are not enabling Segment at all
      // so go ahead and just the function
      runFunction();
    }
  }
};
var _default = exports.default = SegmentUtils;